/**
 * One row in the end-of-session miss list.
 *
 * The shared row prints "term → translation", which is wrong here twice over:
 * a grammar exercise has no translation, and the thing that went wrong was a
 * form, not a meaning. So: the prompt, the form that belonged in it, and what
 * the user put there instead.
 */
import { MissRowFrame, UserAnswer } from '@/components/practice/SharedMissRow';

import { correctAnswerText } from '../shared/grammar/types';
import type { MissRowProps } from '../types';

import { toExercise } from './course';
import type { GramaticaPayload } from './types';

export function MissRow({ card, user_answer }: MissRowProps<GramaticaPayload>) {
  return (
    <MissRowFrame>
      <div className="flex flex-col gap-1">
        <span className="text-muted-foreground text-sm">{card.de}</span>
        <span className="font-display text-lg">{correctAnswerText(toExercise(card.payload))}</span>
        <UserAnswer user_answer={user_answer} verb="wrote" />
      </div>
    </MissRowFrame>
  );
}
